import { render, staticRenderFns } from "./add-registered-user-modal.vue?vue&type=template&id=0ace0344&"
import script from "./add-registered-user-modal.vue?vue&type=script&lang=js&"
export * from "./add-registered-user-modal.vue?vue&type=script&lang=js&"
import style0 from "./add-registered-user-modal.vue?vue&type=style&index=0&id=0ace0344&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports